/**
 * iurop-search-panel.js — panel de búsqueda del header (Kawaicafe).
 * Port del panel de Glucody, adaptado a las clases .kawaii-*.
 * Se abre al enfocar el buscador de escritorio o al tocar la lupa en móvil
 * (a pantalla completa); se cierra con la ✕, Esc, clic fuera o la lupa.
 * Apertura/cierre con transición sutil: [hidden] solo marca el estado
 * inicial/no-JS; la animación va por la clase .is-open (visibility+opacity).
 * Sin Date.now()/Math.random().
 */
(function () {
  'use strict';

  var closeTimer = null;
  var lockedScrollY = null;

  function panel() {
    return document.querySelector('[data-search-panel]');
  }

  // Candado de scroll a prueba de iOS: en móvil el panel va a pantalla completa
  // y Safari ignora overflow:hidden en html/body; body position:fixed sí clava
  // la página de detrás. Solo ≤989 (en escritorio basta el overflow:hidden del
  // html, y así no hay salto de scrollbar).
  function lockScroll() {
    if (!window.matchMedia('(max-width: 989px)').matches || lockedScrollY !== null) return;
    lockedScrollY = window.scrollY || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = -lockedScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }

  function unlockScroll() {
    if (lockedScrollY === null) return;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, lockedScrollY);
    lockedScrollY = null;
  }

  // Devuelve el panel a su estado inicial: fuera los resultados inyectados,
  // vuelve la parrilla por defecto y el campo queda limpio.
  function resetPanel(p) {
    if (!p) return;
    var box = p.querySelector('[data-search-results]');
    var grid = p.querySelector('[data-search-panel-grid]');
    if (box) { box.innerHTML = ''; box.hidden = true; box.classList.remove('is-loading'); }
    if (grid) grid.hidden = false;
    var inputs = p.querySelectorAll('input[name="q"]');
    [].forEach.call(inputs, function (i) { i.value = ''; });
    var head = document.querySelector('.kawaii-header__search input[name="q"]');
    if (head) head.value = '';
  }

  function open() {
    var p = panel();
    if (!p) return;
    clearTimeout(closeTimer);
    if (!p.classList.contains('is-open')) {
      p.hidden = false;
      void p.offsetHeight; // reflow: la transición arranca desde el estado cerrado
      p.classList.add('is-open');
    }
    // el fondo queda bloqueado (en móvil, candado iOS con body fixed)
    document.documentElement.classList.add('kawaii-search-open');
    lockScroll();
    var input = p.querySelector('[data-search-panel-input]');
    if (input && window.matchMedia('(max-width: 989px)').matches) input.focus();
  }

  function close() {
    var p = panel();
    if (!p || p.hidden) return;
    p.classList.remove('is-open');
    document.documentElement.classList.remove('kawaii-search-open');
    unlockScroll();
    // corta la predictiva pendiente: un debounce/fetch en vuelo llamaba a
    // open() al resolver y el panel se REABRÍA solo tras cerrarlo
    clearTimeout(timer);
    seq++;
    clearTimeout(closeTimer);
    closeTimer = setTimeout(function () {
      p.hidden = true;
      // Estado inicial para la proxima apertura: sin esto el panel reabria con
      // los resultados de la busqueda anterior y la parrilla de populares/
      // destacados ya no volvia a verse nunca.
      resetPanel(p);
    }, 240); // tras el fade (0.22s)
  }

  document.addEventListener('focusin', function (e) {
    if (e.target.closest('.kawaii-header__search')) open();
  });

  // La lupa (submit) con el buscador VACÍO no debe navegar a /search?q= —
  // abre el panel y enfoca el campo (píldora de escritorio y formulario
  // del panel móvil).
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.kawaii-header__search, .kawaii-search__panel-form');
    if (!form) return;
    var input = form.querySelector('input[name="q"]');
    if (input && input.value.trim() === '') {
      e.preventDefault();
      open();
      input.focus();
    }
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-close]')) {
      close();
      return;
    }
    var lupa = e.target.closest('.kawaii-header__icon--search-m');
    if (lupa) {
      e.preventDefault();
      var p = panel();
      if (p && !p.classList.contains('is-open')) open();
      else close();
      return;
    }
    if (!e.target.closest('[data-search-panel]') && !e.target.closest('.kawaii-header__search')) close();
  });

  var activeIndex = -1;

  // Enlaces navegables del panel (resultados predictivos o parrilla por defecto).
  function options() {
    var p = panel();
    if (!p) return [];
    var box = p.querySelector('[data-search-results]');
    var scope = (box && !box.hidden) ? box : p.querySelector('[data-search-panel-grid]');
    return scope ? [].slice.call(scope.querySelectorAll('a[href]')) : [];
  }

  function highlight(list, i) {
    list.forEach(function (a, k) {
      a.classList.toggle('is-kbd-active', k === i);
      if (k === i) {
        a.setAttribute('aria-selected', 'true');
        if (a.scrollIntoView) a.scrollIntoView({ block: 'nearest' });
      } else {
        a.removeAttribute('aria-selected');
      }
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { close(); return; }

    var p = panel();
    if (!p || !p.classList.contains('is-open')) return;
    var inSearch = e.target.closest && (e.target.closest('[data-search-panel]') || e.target.closest('.kawaii-header__search'));
    if (!inSearch) return;

    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      var list = options();
      if (!list.length) return;
      e.preventDefault(); // no mover el cursor dentro del input
      activeIndex = e.key === 'ArrowDown'
        ? (activeIndex + 1) % list.length
        : (activeIndex <= 0 ? list.length - 1 : activeIndex - 1);
      highlight(list, activeIndex);
      return;
    }

    if (e.key === 'Enter' && activeIndex > -1) {
      var opts = options();
      if (opts[activeIndex]) { e.preventDefault(); opts[activeIndex].click(); }
    }
  });

  /* ------------------------------------------------------------------ */
  /* Búsqueda predictiva: al teclear se pide la sección                 */
  /* iurop-predictive-search por Section Rendering API y se inyectan    */
  /* CARDS DE PRODUCTO reales (+ colecciones) en el hueco de destacados. */
  /* ------------------------------------------------------------------ */
  var DEBOUNCE_MS = 250;
  var timer = null;
  var seq = 0;
  var inflight = null;   // AbortController de la peticion en curso
  var cache = Object.create(null); // consulta -> html de la seccion
  var cacheKeys = [];    // orden de insercion (LRU simple)
  var CACHE_MAX = 20;

  function cacheGet(q) { return cache[q]; }
  function cachePut(q, html) {
    if (cache[q] === undefined) {
      cacheKeys.push(q);
      if (cacheKeys.length > CACHE_MAX) delete cache[cacheKeys.shift()];
    }
    cache[q] = html;
  }

  // Region viva: los lectores de pantalla anuncian los resultados nuevos sin
  // que el foco salga del input.
  function ensureLive(box) {
    if (!box || box.getAttribute('aria-live')) return;
    box.setAttribute('aria-live', 'polite');
    box.setAttribute('aria-atomic', 'false');
  }

  function partsOf() {
    var p = panel();
    if (!p) return null;
    return {
      box: p.querySelector('[data-search-results]'),
      grid: p.querySelector('[data-search-panel-grid]')
    };
  }

  function showSuggest(show) {
    var el = partsOf();
    if (!el || !el.box) return;
    el.box.hidden = !show;
    if (el.grid) el.grid.hidden = show;
  }

  // Pinta el HTML de la seccion predictiva ya descargado.
  function paint(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var live = doc.querySelector('.kawaii-search__live');
    var el = partsOf();
    if (!live || !el || !el.box) return;
    el.box.innerHTML = '';
    el.box.appendChild(live);
    open();
    showSuggest(true);
    setBusy(false);
    activeIndex = -1; // la navegacion por teclado empieza de cero en cada consulta
  }

  // Marca el panel como "cargando" (el CSS baja la opacidad de los resultados)
  // y lo anuncia a lectores de pantalla via aria-busy.
  function setBusy(on) {
    var el = partsOf();
    if (!el || !el.box) return;
    ensureLive(el.box);
    el.box.classList.toggle('is-loading', !!on);
    el.box.setAttribute('aria-busy', on ? 'true' : 'false');
  }

  function fetchResults(q) {
    var mySeq = ++seq;
    var hit = cacheGet(q);
    if (hit !== undefined) { paint(hit); return; } // ya la teniamos: sin red

    // Cancela la peticion anterior: sin esto seguia descargando aunque su
    // resultado ya no se fuera a pintar (datos y ancho de banda en movil).
    if (inflight) inflight.abort();
    var ctrl = null;
    try { ctrl = new AbortController(); inflight = ctrl; } catch (err) { inflight = null; }

    setBusy(true);
    var base = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
    fetch(base + '?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=8&section_id=iurop-predictive-search',
      ctrl ? { signal: ctrl.signal } : undefined)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        if (mySeq !== seq) return; // respuesta vieja, fuera
        cachePut(q, html);
        paint(html);
      })
      .catch(function () { if (mySeq === seq) setBusy(false); }); // abort o red caida
  }

  document.addEventListener('input', function (e) {
    var input = e.target.closest('.kawaii-header__search input[name="q"], [data-search-panel-input]');
    if (!input) return;
    var q = input.value.trim();
    clearTimeout(timer);
    if (!q.length) {
      seq++; // invalida respuestas en vuelo
      if (inflight) { inflight.abort(); inflight = null; }
      setBusy(false);
      showSuggest(false);
      return;
    }
    // destacados/populares fuera desde la primera letra; las cards llegan
    // en ~150ms (los enlaces navegan a la PDP directamente)
    timer = setTimeout(function () { fetchResults(q); }, DEBOUNCE_MS);
  });
})();
